// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_overlay__29srO","overlay_cancel":"modal_overlay_cancel__2at8G","modal":"modal_modal__21EtB","modal_cancel":"modal_modal_cancel__3TVY3"};